const positions = [{
  company: 'Supply Chain Intelligence Institute Austria (ASCII)',
  position: 'Data Engineer',
  link: 'https://ascii.ac.at',
  daterange: 'Nov 2023 - Present',
  points: [
    'Built and maintained web-scale ETL pipelines over Common Crawl using Dagster and Spark/EMR.',
    'Processed and analyzed large volumes of website data (42M hosts) to extract signals for potential supply-chain relationships.',
    'Produced firm-level descriptive features from company websites: content extraction, aggregation, and QA for downstream modeling.',
    'Migrated workloads from EMR to the Vienna Scientific Cluster (HPC), reducing compute cost by ~50% (average crawl processing cost ~€200).',
    'Implemented data-quality controls (dedup/boilerplate filtering, language filtering) to improve downstream retrieval and modeling.',
  ],
}, {
  company: 'JPMorgan Chase',
  position: 'Senior Software Engineer',
  link: 'https://www.jpmorgan.com',
  daterange: 'Jan 2023 - Feb 2024',
  points: [
    'Maintained and extended a Fixed Income asset-exchange platform for Emerging Markets.',
    'Migrated services to Kubernetes and later AWS, and implemented client-facing features.',
    'Upgraded and modernized the codebase to run on Java 21.',
  ],
}, {
  company: 'ZhiShou Technology',
  position: 'Algorithm Engineer',
  daterange: 'Dec 2020 - Feb 2023',
  points: [
    'Developed large-scale distributed genetic algorithms with Generalized Additive Models for time-series forecasting.',
    'Built video and image anomaly detection and classification with DL4J and TensorFlow.',
  ],
}, {
  company: 'Project Agora',
  position: 'Data Scientist',
  daterange: 'Apr 2019 - Nov 2020',
  points: [
    'Built APIs for text recognition and analysis, and developed business analytics dashboards.',
    'Performed market segmentation and risk analysis.',
    'Conducted NLP work (topic modeling, sentiment analysis) in R and Python.',
  ],
}, {
  company: 'University of California, San Diego',
  position: 'Graduate Research Assistant',
  link: 'http://ucsd.edu',
  daterange: 'Jan 2019 - Jun 2019',
  Supervisor: 'Under Prof. Scott Desposato:',
  points: [
    'Scraped political campaign videos and audio from across Latin America.',
    'Automated translation and transcription using Google, Azure and AWS APIs.',
    'Built politician identification in video using neural networks.',
    'Performed text analysis of political campaign material.',
  ],
}, {
  company: 'University of California, San Diego',
  position: 'Graduate Research Assistant',
  link: 'http://ucsd.edu',
  daterange: 'Jul 2017 - Dec 2018',
  Supervisor: 'Under Prof. Margaret (Molly) Roberts:',
  points: [
    'Text analysis of Chinese media, policy and court cases.',
    'Built a web app for live Twitter analysis and ran A/B tests for implicit bias detection.',
    'Automated bot detection and inferred political identity on Twitter.',
  ],
}, {
  company: 'University of CEMA',
  position: 'Junior Data Analyst',
  link: 'http://ucema.edu.ar',
  daterange: 'May 2013 - 2015',
  points: [
    'Analysis of voting behavior in Buenos Aires.',
    'Evaluation of the prostitution market in Argentina.',
    'Detecting patterns in capital flows.',
  ],
}, {
  company: 'NPSGlobal Foundation',
  position: 'Front-End Developer',
  link: 'http://npsglobal.org/',
  daterange: 'May 2012 - Dec 2015',
  points: [
    'Maintenance of the website, ensuring responsiveness and managing the database.',
    'Supervised interns on document uploads and content creation.',
  ],
},
];

export default positions;
